import { createSvgComponent } from "../../icon/createSvgComponent";
import HandHeldWriting from "@core/__generated__/icon/figma/hand-held-writing.svg";
export default createSvgComponent(HandHeldWriting);